export default emitter => {
	let currentTransitionAttempt = null
	let nextTransition = null

	function doneTransitioning() {
		currentTransitionAttempt = null
		if (nextTransition) {
			beginNextTransitionAttempt()
		}
	}

	const isTransitioning = () => !!currentTransitionAttempt

	function beginNextTransitionAttempt() {
		currentTransitionAttempt = nextTransition
		nextTransition = null
		currentTransitionAttempt.beginStateChange()
	}

	function cancelCurrentTransition() {
		currentTransitionAttempt.transition.cancelled = true
		const err = new Error(`State transition cancelled by the state transition manager`)
		err.wasCancelledBySomeoneElse = true
		emitter.emit(`stateChangeCancelled`, err)
	}

	emitter.on(`stateChangeAttempt`, beginStateChange => {
		nextTransition = createStateTransitionAttempt(beginStateChange)

		if (isTransitioning() && currentTransitionAttempt.transition.cancellable) {
			cancelCurrentTransition()
		} else if (!isTransitioning()) {
			beginNextTransitionAttempt()
		}
	})

	emitter.on(`stateChangeError`, doneTransitioning)
	emitter.on(`stateChangeCancelled`, doneTransitioning)
	emitter.on(`stateChangeEnd`, doneTransitioning)

	function createStateTransitionAttempt(beginStateChange) {
		const transition = {
			cancelled: false,
			cancellable: true,
		}
		return {
			transition,
			beginStateChange: (...args) => beginStateChange(transition, ...args),
		}
	}
}
